import { BotIcon, CheckCircle } from "lucide-react";
import Edit2Icon from "../../../../assets/icons/Edit2Icon";
import Message from "../../../../i18n/Message";
import modelDescriptors, {
  currentModelDescriptions,
} from "../../../../model/model-providers/modelDescriptors";
import "./AssistantSystemMessage.scss";

const AssistantSystemMessage = ({ assistant, chat, setShowSettings }) => {
  const model = currentModelDescriptions.find(
    (item) => item.id === chat.modelId
  );
  const oldModel = modelDescriptors.find((item) => item.id === chat.modelId);

  return (
    <div className="assistant_system_message">
      <div className="avatar">
        <div className="avatar_wrapper">
          <BotIcon size={20} color="#555" />
        </div>
      </div>
      <div className="message_body">
        <div className="assistant_name">{assistant.name}</div>
        {assistant.description && (
          <div className="assistant_description">{assistant.description}</div>
        )}
        <div className="model_info">
          <Message
            id="model_message_model_name"
            values={{
              name: (model || oldModel).name,
            }}
          />
        </div>
        {assistant.agenticMode && (
          <div className="agentic_mode_badge">
            <CheckCircle size={14} color="green" strokeWidth={2} />
            <span
              style={{
                marginLeft: "4px",
                color: "green",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              <Message id="assistant_agentic_mode_enabled" />
            </span>
          </div>
        )}
        <div className="system_prompt">
          <Message id="model_message_system_prompt" />: {chat.systemPrompt}
        </div>
      </div>
      <div className="message_actions">
        <button
          className="btn no-btn tile-action"
          onClick={() => setShowSettings(true)}
        >
          <Edit2Icon size="16" color="#344767" />
          <Message id="edit" />
        </button>
      </div>
    </div>
  );
};

export default AssistantSystemMessage;
